<template>
  <WdsStack
    direction-column
    align-center
    justify-space-between
    class="tw-bg-white tw-shadow tw-w-[294px] tw-h-60 tw-gap-7 tw-p-7.5 tw-cursor-wait"
  >
    <slot name="icon">
      <WdsAvatar path="/gifs/loading-avatars.gif" xxl></WdsAvatar>
    </slot>
    <div>
      <div class="tw-text-gray-900 tw-font-display tw-text-xl tw-leading-7">
        <slot name="main">{{ $t('Loading') }}</slot>
      </div>
      <div class="tw-text-gray-600 tw-font-circular tw-text-lg tw-leading-6">
        <slot name="sub">
          {{ $t('One moment please...') }}
        </slot>
      </div>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsAvatar } from '@worksome/wds-components'
import { $t } from '@/composables/translation'
</script>

<style scoped lang="scss"></style>
